import { signal } from "@preact/signals-react"

export const businessEntitiesLoadedSignal = signal(false)
export const businessEntitiesErrorSignal = signal(null)
export const currentBusinessEntitySignal = signal(null)
export const rootBusinessEntitySignal = signal(null)
export const businessEntityDictionarySignal = signal({})
export const ancestorBEIDsSetSignal = signal(new Set())